export default __webpack_public_path__ + "static/media/other.8bac89a9.png";